import { Reveal, SectionHeader } from "./shared";
import { collaborations } from "../../data/portfolioData";

export const CollaborationsSection = () => (
  <section id="collaborations" className="py-20 lg:py-28" data-testid="collaborations-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="09"
        eyebrow="Ecosystem & Impact"
        title="Clients & Collaborations"
        description="Companies, partnerships and teams I've worked with."
        testId="collaborations-header"
      />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {collaborations.partners.map((p, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <div
              className="flex h-28 items-center justify-center rounded-2xl border border-dashed border-white/[0.12] bg-[#0C101A] transition-colors duration-300 hover:border-amber-400/25"
              data-testid={`partner-slot-${i}`}
            >
              <span className="font-code text-xs text-slate-600">{p.name}</span>
            </div>
          </Reveal>
        ))}
      </div>

      {collaborations.testimonials.length === 0 && (
        <Reveal delay={0.2}>
          <p className="mt-8 text-center font-code text-xs text-slate-600" data-testid="testimonials-placeholder-note">
            // Testimonials will appear here — real quotes from real clients only.
          </p>
        </Reveal>
      )}
    </div>
  </section>
);
